import _ from 'lodash';
import { colorToString } from '../components/widgets/widget.helper';

//BoxShadow
export function getBoxShadow(value) {
    if (!value) {
      return null;
    }
    var styles = {};

    var shadowColor = colorToString( _.get(value, 'color', {r: 255, g: 255, b: 255, a: 1}));
    var xValue = _.get(value, 'axes.x', 0);
    var yValue = _.get(value, 'axes.y', 0);
    var bValue = _.get(value, 'axes.b', 0);
    var showShadow = _.get(value, 'show', false);

    if(!showShadow) {
     return null;
    }
    var boxShadow = `${xValue}px ${yValue}px ${bValue}px ${shadowColor}`
    styles['boxShadow'] = boxShadow

    return styles;
  }


//DropShadow
export function getDropShadow(value) {

  if (!value) {
    return null;
  }

  var shadowColor = colorToString( _.get(value, 'color', {r: 255, g: 255, b: 255, a: 1}));
  var xValue = _.get(value, 'axes.x', 0);
  var yValue = _.get(value, 'axes.y', 0);
  var bValue = _.get(value, 'axes.b', 0);
  var showShadow = _.get(value, 'show', false);

  if(!showShadow) {
    return null;
  }

  var shadow = {
    "filter": `drop-shadow(${xValue}px ${yValue}px ${bValue}px ${shadowColor})`,
    "WebkitFilter": `drop-shadow(${xValue}px ${yValue}px ${bValue}px ${shadowColor})`
  };

  const isSafari = typeof window !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : false;
  if (isSafari) {
    shadow = {
      ...shadow,
      "willChange": "filter"
    }
  }

  return shadow;
}
